"use client"

import { LeafletItem } from "@/components/leaflet/types"
import { getFixedT } from "@/languages/i18n"
import Image from "next/image"
import Link from "next/link"

interface LeafletCardProps {
    item: LeafletItem
    locale: string
    index: number
}

export const LeafletCard = ({ item, locale, index }: LeafletCardProps) => {
    const t = getFixedT(locale)
    return (
        <Link
            key={item.id || index}
            href={item.status === "upcoming" ? "#" : `/${locale}/letak/${item.slug || item.id}`}
            className="flex flex-col group cursor-pointer sm:gap-3 gap-[5px]"
        >
            <div className="relative w-full sm:h-[345px] h-[200px] overflow-hidden rounded-lg">
                {item.image ? (
                    <>
                        <Image
                            src={item.image}
                            alt={item.title}
                            fill
                            className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
                        />
                        {item.status === "upcoming" && (
                            <div className="absolute inset-0 flex items-center justify-center bg-black/70 z-10">
                                <span className="text-white text-base leading-[24.8px] font-bold uppercase">
                                    {t("Coming soon")}
                                </span>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400">{t("No Image")}</div>
                )}
            </div>
            <h3 className="sm:text-xl sm:leading-[31px] text-base leading-[24.8px] font-bold text-[#333] group-hover:text-[#008000] transition-all duration-300">
                {item.title}
            </h3>
        </Link>
    )
}